import React from "react";

const Skeleton = ({
  width,
  height = 16,
  borderRadius = 10,
  style,
  variant = "text",
  count = 1,
  gap = 8,
}) => {
  const base = {
    background:
      "linear-gradient(90deg, var(--neutral-light, #F8FAFC) 25%, #E5E7EB 50%, var(--neutral-light, #F8FAFC) 75%)",
    backgroundSize: "1000px 100%",
    animation: "shimmer 2s infinite",
    borderRadius,
    width,
    height,
  };

  if (variant === "circle") {
    base.borderRadius = "50%";
    base.width = width || height;
    base.height = height;
  }

  if (variant === "rect") {
    base.width = width || "100%";
    base.height = height;
  }

  if (variant === "text") {
    base.width = width || "100%";
    base.height = height;
  }

  if (count > 1) {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap }}>
        {Array.from({ length: count }).map((_, i) => (
          <div
            key={i}
            style={{
              ...base,
              width: typeof width === "string" ? width : `${Math.max(60, 100 - i * 10)}%`,
            }}
          />
        ))}
      </div>
    );
  }

  return <div style={base} />;
};

export default Skeleton;
